import React from 'react'

const LayersIcon = ({color = 'currentColor', width = 24, height = 24, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0733 1.12877C11.3466 0.957079 11.7005 0.957076 11.9738 1.12876L21.6775 7.22381C21.9071 7.36804 22.046 7.61264 22.0475 7.87542C22.049 8.13819 21.913 8.38426 21.685 8.53091L11.9814 14.774C11.7046 14.9521 11.3426 14.9521 11.0658 14.774L1.3625 8.5309C1.13456 8.38425 0.998493 8.13819 1.00001 7.87542C1.00153 7.61265 1.14044 7.36805 1.37006 7.22381L11.0733 1.12877ZM11.5236 2.72348L3.30234 7.8876L11.5236 13.1772L19.7452 7.8876L11.5236 2.72348Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.95421 9.97909C5.20288 10.3414 5.09747 10.8279 4.71877 11.0658L3.30234 11.9555L11.5236 17.245L19.7452 11.9555L18.3287 11.0658C17.95 10.8279 17.8446 10.3414 18.0932 9.9791C18.3419 9.61683 18.8505 9.51598 19.2292 9.75385L21.6775 11.2917C21.9071 11.4359 22.046 11.6805 22.0475 11.9433C22.049 12.2061 21.913 12.4521 21.685 12.5988L11.9814 18.8419C11.7046 19.02 11.3426 19.02 11.0658 18.8419L1.3625 12.5988C1.13456 12.4521 0.998493 12.2061 1.00001 11.9433C1.00153 11.6805 1.14044 11.4359 1.37006 11.2917L3.81826 9.75386C4.19696 9.51598 4.70554 9.61682 4.95421 9.97909Z"
            fill={color}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.95421 14.0494C5.20288 14.4117 5.09747 14.8982 4.71877 15.1361L3.30234 16.0258L11.5236 21.3153L19.7452 16.0258L18.3287 15.1361C17.95 14.8982 17.8446 14.4117 18.0932 14.0494C18.3419 13.6871 18.8505 13.5863 19.2292 13.8242L21.6775 15.362C21.9071 15.5062 22.046 15.7508 22.0475 16.0136C22.049 16.2764 21.913 16.5224 21.685 16.6691L11.9814 22.9122C11.7046 23.0903 11.3426 23.0903 11.0658 22.9122L1.3625 16.6691C1.13456 16.5224 0.998493 16.2764 1.00001 16.0136C1.00153 15.7508 1.14044 15.5062 1.37006 15.362L3.81826 13.8242C4.19696 13.5863 4.70554 13.6871 4.95421 14.0494Z"
            fill={color}
        />
    </svg>
)

export default LayersIcon
